<template>
    <div class="content pa-6 pa-md-8 pb-6 contact my-12">
        <v-row>
            <v-col class="d-flex justify-center pt-0">
                <h1 class="text-center">Unsubscribe</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pb-0">
                <form>
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field
                                    v-model="email"
                                    :error-messages="emailErrors"
                                    label="Email Address"
                                    required
                                    outlined
                                    class="btn-edu-height"
                                    @blur="$v.email.$touch()"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-checkbox
                                        label="Unsubscribe All Emails"
                                        class="py-0 consent-text"
                                        v-model="unsubscribe_email"
                                        default="true"
                                        hide-details
                            >
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-checkbox
                                        label="Unsubscribe All SMS Messages"
                                        class="py-0 consent-text"
                                        v-model="unsubscribe_sms"
                                        default="true"
                                        hide-details
                            >
                            </v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-btn
                                    @click="submit"
                                    color="primary"
                                    block
                                    class="btn-edurent"
                                    height="45"
                                    :loading="isSendingMessage"
                            >
                                Update Settings
                            </v-btn>
                        </v-col>
                    </v-row>
                </form>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import {formatPhoneNumber} from "@/utils/utils";

export default {
    validations: {

        email: { required, email },
    },

    data: () => ({
        email: '',
        unsubscribe_email: false,
        unsubscribe_sms: false,
        isSendingMessage: false
    }),
    computed: {
        emailErrors () {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push('Must be valid e-mail')
            !this.$v.email.required && errors.push('E-mail is required')
            return errors
        }
    },
    methods: {
        async submit () {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'Mandatory field(s) required for unsubscribe',
                    color: 'red'
                });

              return;
            }

            // send contact message
          this.isSendingMessage = true
            await this.$store.dispatch('updateUnsubscribe', {
                email: this.email,
                opt_out_email: this.unsubscribe_email,
                opt_out_sms: this.unsubscribe_sms
            })

          this.isSendingMessage = false
          this.clear();
        },
        formatPhoneNumber() {
          this.$v.phone.$touch();
          this.phone = formatPhoneNumber(this.phone);
        },
        clear () {
            this.$v.$reset()

            this.email = ''
            this.message = ''
            this.select = null
            this.checkbox = false
        },
    },
    beforeMount() {
        // set the menu to normal
        this.$store.commit('setHeaderMenuState');
    }
}
</script>

<style scoped>
    .contact {
        max-width: 540px;
        border: 1px solid #d8d8d8;
        border-radius: 10px;
    }
    .contact h1 {
        font-size: 20px !important;
        font-weight: 700;
    }

    @media (max-width: 1024px) {
        .contact {
            width: 90%;
            margin: 0 auto;
        }
    }
</style>
